var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColumnStacked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 7.6h-2.1a.4.4 0 00-.4.3v2a.4.4 0 00.4.4h2.1a.4.4 0 00.4-.3V8a.4.4 0 00-.4-.4zm6 4.8h-2.1a.4.4 0 00-.4.4v3.6a.4.4 0 00.4.4h2.1a.4.4 0 00.3-.4v-3.6s-.1-.4-.3-.4zm5.8-1.6H24a.3.3 0 00-.3.3v3.2a.3.3 0 00.3.3h2.2a.3.3 0 00.3-.3v-3.2a.3.3 0 00-.4-.3zM8.5 2H6.4c-.4.1-.4.3-.4.5v4l.3.1h2.2a.4.4 0 00.3-.3v-4a.4.4 0 00-.3-.3z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 9h2.4c.2 0 .3.1.3.3v12c0 .2-.1.3-.3.3H6.3a.3.3 0 01-.3-.3v-12c0-.2.1-.3.3-.3zm5.9 12.6h2.3c.2 0 .2-.2.3-.4v-8.6l-.3-.3h-2.3c-.2 0-.4.1-.4.3v8.6c0 .2.2.4.4.4zm11.8.1h2.3c.2 0 .2-.1.3-.3v-4.6c0-.2 0-.4-.3-.4H24c-.2 0-.4.2-.3.4v4.6c0 .2.1.3.3.3zm-5.8 0h2.3c.2 0 .2-.1.3-.3v-2.2c0-.2-.1-.3-.3-.3h-2.3c-.2 0-.4.1-.4.3v2.2c0 .2.2.3.4.3zm11.4 2.9H3V.3c0-.2-.2-.4-.4-.3H.4C.2 0 0 .1 0 .3v26.8c0 .2.2.3.4.3h29.2c.2 0 .4-.1.4-.3v-2.2c0-.2-.2-.3-.4-.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnStacked);
export default __webpack_public_path__ + "static/media/column-stacked.782cbd0f.svg";
export { ForwardRef as ReactComponent };